import React from 'react';
import Icon from '../AppIcon';

const AmbiguousMatchesCounter = ({ 
  count = 0, 
  priority = 'normal',
  onClick = null,
  className = '' 
}) => {
  if (count === 0) {
    return null;
  }

  const getPriorityConfig = () => {
    switch (priority) {
      case 'high':
        return {
          bgColor: 'bg-error',
          textColor: 'text-error-foreground',
          pulseClass: 'animate-pulse',
          icon: 'AlertTriangle'
        };
      case 'medium':
        return {
          bgColor: 'bg-warning',
          textColor: 'text-warning-foreground',
          pulseClass: '',
          icon: 'AlertCircle'
        };
      default:
        return {
          bgColor: 'bg-primary',
          textColor: 'text-primary-foreground',
          pulseClass: '',
          icon: 'Eye'
        };
    }
  };

  const config = getPriorityConfig();
  const isClickable = typeof onClick === 'function';

  const handleClick = () => {
    if (isClickable) {
      onClick();
    }
  };

  return (
    <div className={`
      inline-flex items-center space-x-1.5 px-2 py-1 rounded-full text-xs font-medium
      ${config?.bgColor} ${config?.textColor} ${config?.pulseClass}
      ${isClickable ? 'cursor-pointer hover:scale-105 transition-transform duration-150' : ''}
      shadow-sm border border-white border-opacity-20
      ${className}
    `}
    onClick={handleClick}
    title={`${count} item${count !== 1 ? 's' : ''} need${count === 1 ? 's' : ''} manual review`}
    >
      <Icon 
        name={config?.icon} 
        size={10} 
      />
      <span className="font-mono font-semibold">
        {count > 99 ? '99+' : count}
      </span>
      <span className="hidden sm:inline">
        {count === 1 ? 'match' : 'matches'}
      </span>
    </div>
  );
};

export default AmbiguousMatchesCounter;